import { ReactNode } from 'react';

import { Tooltip } from 'shared';
import Box from 'shared_DEPRECATED/components/Box';
import Button from 'shared_DEPRECATED/components/Button';
import { FlexItem } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { useColorMode } from 'shared/components/ColorMode/useColorMode';
import { Typography } from 'shared/components/Typography';

const getColorConfig = ({
  theme,
  isMy,
  isThemeLight,
}: {
  theme: 'light' | 'dark';
  isMy: boolean;
  isThemeLight: boolean;
}) => {
  switch (theme) {
    case 'dark':
      return {
        backgroundColor: 'var(--whiteAlpha30)',
        borderColor: isMy ? 'var(--white)' : 'transparent',
      };
    case 'light':
    default:
      return {
        backgroundColor: isMy
          ? isThemeLight
            ? 'var(--bgCompMinorAccent)'
            : 'transparent'
          : 'var(--gray25)',
        borderColor: isMy ? 'var(--fgInteractive)' : 'transparent',
      };
  }
};

type ReactionsCountButtonPropTypes = {
  children: ReactNode;
  isMy: boolean;
  onClick: () => void;
  tooltipText: string;
  dataTestid?: string;
  theme: 'light' | 'dark';
};

export const ReactionsCountButton = ({
  children,
  isMy,
  onClick,
  tooltipText,
  dataTestid = '',
  theme = 'light',
}: ReactionsCountButtonPropTypes) => {
  const { colorMode: curTheme } = useColorMode();
  const isThemeLight = curTheme === 'light';

  const { backgroundColor, borderColor } = getColorConfig({
    theme,
    isMy,
    isThemeLight,
  });

  return (
    <FlexItem flexShrink={0}>
      <Tooltip
        content={
          <Typography color="white" fontWeight="medium" type="small">
            {tooltipText}
          </Typography>
        }
        positioning={{
          offset: 8,
        }}
        asChild
      >
        <Button onClick={onClick} dataTestid={dataTestid}>
          <Box
            style={{
              backgroundColor,
              borderRadius: 'var(--border-radius12)',
              border: `1px solid ${borderColor}`,
            }}
          >
            <Spacer size="sm">
              <Spacer size="zr xsm">{children}</Spacer>
            </Spacer>
          </Box>
        </Button>
      </Tooltip>
    </FlexItem>
  );
};
